import { useState } from "react";
import Modal from "../../components/Modal";
import {
  Container,
  LeftSide,
  RightSide,
  Title,
  FlexDivLeft,
  FlexDivRight,
  BorderDiv,
  BorderDivIn,
  LeftDiv,
  RightDiv,
  Check,
  ModalButton,
} from "./styles";

const ConfirmationModal = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Container>
      {/* <Title>
        Confirme os detalhes da sua solicitação de reserva em Hotel AMERIS
      </Title>
      <LeftSide>
        <h3>Destino</h3>
        <h4>Rio de Janeiro, RJ, Brasil</h4>
        <h3>Hotel</h3>
        <h4>Hotel AMERIS</h4>
        <h4>
          Sed ut perspiciatis unde omnis iste natus error unde omnis iste natus
          error - 00000-000
        </h4>
        <h3>Data de Estadia</h3>
        <h4>00/00/00 - 00/00/00</h4>
        <h4>Y diárias</h4>
      </LeftSide>
      <RightSide>
        <FlexDivLeft>
          <h3>Quarto</h3>
          <h4>Quarto Single</h4>
          <h4>- Acomoda uma pessoa</h4>
          <h4>- Uma cama de solteiro</h4>
        </FlexDivLeft>

        <FlexDivRight>
          <h3>Número de Hóspedes</h3>
          <h4>X adultos e Y crianças</h4>
        </FlexDivRight>

        <BorderDiv>
          <BorderDivIn>
            <LeftDiv>
              <h1>Minhas Diárias</h1>
              <h1>Estadia</h1>
            </LeftDiv>

            <RightDiv>
              <h1>X diárias</h1>
              <h1>Y diárias</h1>
            </RightDiv>
            <hr />

            <LeftDiv>
              <h1>Diárias Restantes</h1>
            </LeftDiv>

            <RightDiv>
              <h1 className="gradienteH1">Z diárias</h1>
            </RightDiv>
          </BorderDivIn>
        </BorderDiv>
      </RightSide>
      <Check>
        <label>
          <input type="checkbox" />
          <span>Confirmar os detalhes da solicitação</span>
        </label>
      </Check> */}
      <ModalButton
        className="openModalBtn"
        onClick={() => {
          setOpenModal(true);
        }}
      >
        <h1>Solicitar minhas Férias!</h1>
      </ModalButton>
      {openModal && <Modal closeModal={setOpenModal}/>}
    </Container>
  );
};

export default ConfirmationModal;
